import { Component } from '@angular/core'
import { SocialAiChartComponent } from '../../components/tables/social-ai-chart/social-ai-chart.component'
import { SocialAiDashboardTableComponent } from '../../components/tables/social-ai-dashboard-table/social-ai-dashboard-table.component'
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-social-ai-dashboard',
  standalone: true,
  imports: [SocialAiChartComponent, SocialAiDashboardTableComponent, RouterOutlet],
  templateUrl: './social-ai-dashboard.component.html',
  styleUrl: './social-ai-dashboard.component.scss'
})
export class SocialAiDashboardComponent {

}
